export default {"src":"/_next/static/media/setting-goals-archery.colour.ee056929.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};